var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Acesso Proibido")]),_c('p',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.erroMsg)),_c('br'),_vm._v(" Endereço bloqueado: "+_vm._s(_vm.$route.query.url)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }